import React, { useEffect, useState } from "react";
import { useSite } from "@/i18n/SiteContext";
import { api } from "@/lib/api";
import { PackageCard } from "@/components/site/PackageCard";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/images";

export default function PackagesPage() {
  const { t } = useSite();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/packages").then((r) => setList(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="packages-page">
      <section className="relative h-[52vh] min-h-[400px] flex items-end overflow-hidden" data-testid="packages-hero">
        <img src={IMAGES.packages} alt="Amalfi" className="absolute inset-0 w-full h-full object-cover" />
        <div className="hero-overlay absolute inset-0" />
        <Reveal className="relative max-w-6xl mx-auto w-full px-6 pb-14">
          <p className="text-xs font-medium tracking-super-wide text-sand-brand uppercase mb-4">{t("pkg.pageEyebrow")}</p>
          <h1 className="font-serif text-4xl md:text-6xl text-ivory font-normal leading-tight">{t("pkg.pageTitle")}</h1>
          <p className="mt-4 text-base md:text-lg text-ivory/85 max-w-2xl leading-relaxed">{t("pkg.pageSub")}</p>
        </Reveal>
      </section>
      <section className="px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto">
          <p className="text-xs tracking-[0.2em] uppercase text-sea mb-8" data-testid="packages-discount-note">{t("pkg.discountNote")}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {loading
              ? [0, 1, 2].map((i) => <div key={i} className="h-[520px] rounded-3xl bg-sand/50 animate-pulse" />)
              : list.map((p, i) => <PackageCard key={p.id} pkg={p} index={i} />)}
          </div>
          {!loading && list.length === 0 && <p className="text-ocean/60 text-center py-16" data-testid="packages-empty">{t("pkg.empty")}</p>}
        </div>
      </section>
    </div>
  );
}
